app.navPrimary = {
    settings: {
        $el: $('.nav-primary')
    },

    init: function(){
        if(app.primaryNav.settings.$el.length > 0){
        }
    }
};